import React, { Component } from 'react';
import Search from '../../../components/Search';
import DataTable from '../../../components/DataTable';
import { connect } from 'react-redux'
import {Card, CardBody, CardTitle, Row} from "reactstrap";
import { setSearchData } from '../../../actions/search';

import {withRouter} from 'react-router';
import classnames from 'classnames';

import { uploadFile, removeLastFileId, fileEdited } from '../../../actions/file';
import FileMetaForm from './FileMetaForm';
import Dropzone from 'react-dropzone'
import lodash  from 'lodash/array';
import { withStyles } from 'material-ui/styles';
import { CircularProgress } from 'material-ui/Progress';
import { editingInProgress } from '../../../actions/loaderAction';
import { getAllFiles }  from '../../../actions/file';
import { getAllProducts } from '../../../actions/product';
import {fileTypeFetchData, fileMetaDataValueWithCategoryFetchData, fileMetaDataValueFetchData} from '../../../actions/fileData'
import {clientFetchData} from '../../../actions/clientData'
import Loader from '../../../components/Loader';
class Form extends Component {

    constructor(props,context) {
        super(props,context);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.setFileType = this.setFileType.bind(this);
        this.setProductId = this.setProductId.bind(this);
        this.setMessageOption = this.setMessageOption.bind(this);
        this.setCheckedValue = this.setCheckedValue.bind(this);
        this.getButtonMessage = this.getButtonMessage.bind(this);
        this.setIsBeenNotified = this.setIsBeenNotified.bind(this);
        this.setTextValue = this.setTextValue.bind(this);
        this.setAddress = this.setAddress.bind(this);
        this.state = {newFile: false, metaDataValueLoaded: false, productsLoaded: false, fileTypeDataLoaded: false, metaDataValueByCategoryLoaded: false, fileDataLoaded: false, dataLoaded:false, files: [], send_message: 1, is_priority:0, is_been_notified:0, fileEdit:false, attached_values: false, file_type_id: false, product_id: '1', selectedAddress: {'value': false, 'label' : false}, 'uploaded_by': this.props.user.userId }
        this.getFilePreview = this.getFilePreview.bind(this);


    }



    setCheckedValue(value, categoryId) {
        
        let metaDataValue = false;
        if ( this.props.metaDataValue instanceof Array ) {
            metaDataValue = this.props.metaDataValue.find(e => e.id === value);

        } else {
            for ( let property in this.props.metaDataValue ) {
                if ( this.props.metaDataValue.hasOwnProperty(property) ) {
                    if ( this.props.metaDataValue[property].id === value ) {
                        metaDataValue = this.props.metaDataValue[property];
                    }
                }
            }
        }

        if(metaDataValue) {
            if(metaDataValue.is_notifier == '1') {

             this.setState({is_priority: 1 })
            }

        }

        this.setState({
            attached_values: {...this.state.attached_values,[categoryId]: value}
        })
    }

    setFileType(e) {
         this.setState({
            file_type_id: e.target.value
        })

        this.setState({
            attached_values: false
        })
    }

    setProductId(e) {
         this.setState({
            product_id: e.target.value
        })
    }

    setIsBeenNotified(e) {
         this.setState({
            is_been_notified: e.target.value
        })
    }

    setAddress(selectedOption) {
        this.setState({ selectedAddress: selectedOption });
    }

    setMessageOption(e) {


        if(e.target.name == 'is_priority') {
           
            this.setState({
                is_priority: e.target.checked ? 1 : 0
            })
        }

        if(e.target.name == 'send_message') {
            this.setState({
                send_message: e.target.checked ? 1 : 0
            })
        }

    }

    setTextValue(e) {
        if(e.target.value != "" || this.state.attached_values[e.target.name+'_text']) {            
            this.setState({
                attached_values: {...this.state.attached_values,[e.target.name+'_text']: e.target.value}
            })
        }
    }

    componentWillMount() {
        if(this.props.clientPath.clientPath) {
            this.props.getAllFiles(this.props.clientPath.clientPath)
            this.props.getAllProducts(this.props.clientPath.clientPath)
            this.props.fileTypeFetchData(this.props.clientPath.clientPath)
            this.props.fileMetaDataValueWithCategoryFetchData(this.props.clientPath.clientPath)
            this.props.fileMetaDataValueFetchData(this.props.clientPath.clientPath)
          //  this.props.clientFetchData(this.props.clientPath.clientPath)
        }
    }


    componentDidUpdate(prevprops, prevstate) {

        // -- check if all data is loaded
        if(prevprops.products != this.props.products)
            this.setState({productsLoaded: true})

        if(prevprops.fileTypeData.data != this.props.fileTypeData.data)
            this.setState({fileTypeDataLoaded: true})

        if(prevprops.metaDataValueByCategory != this.props.metaDataValueByCategory)
            this.setState({metaDataValueByCategoryLoaded: true})

        if(prevprops.fileData.files != this.props.fileData.files)
            this.setState({fileDataLoaded: true})

        if(prevprops.metaDataValue != this.props.metaDataValue)
            this.setState({metaDataValueLoaded: true})
       

        if(!prevstate.dataLoaded && this.state.fileDataLoaded &&
           this.state.metaDataValueByCategoryLoaded &&
           this.state.fileTypeDataLoaded &&
           this.state.productsLoaded &&
           this.state.metaDataValueLoaded) {
            this.setState({dataLoaded: true});
           }

        if(this.props.hasBeenEdited) {
            let addressId = this.state.selectedAddress.value;

            if(this.props.match.params.addressId) {
                addressId = this.props.match.params.addressId;
            }

            if(this.props.match.params.fileId && prevstate.file != this.state.file) {
                addressId = this.state.file.addresses[0].value;
            }

            this.props.fileEdited(false);

            if(addressId) {
                this.props.history.push('/addresses/view/' + addressId);
            }
        }

        if(prevstate.dataLoaded != this.state.dataLoaded) {
            const fileId = this.props.match.params.fileId;

            if(fileId) {
                if(this.state.file != this.props.fileData.files.find(e => e.id === fileId)) {
                    this.setState({
                        file: this.props.fileData.files.find(e => e.id === fileId)
                    })
                }
            }

            if(prevstate.selectedAddress.value != this.state.selectedAddress.value) {
                const stateAddressId = this.state.selectedAddress.value;
                const addressIndex = lodash.findIndex(this.props.clientData.allAddresses, function(value) { return value.dp_address_id === stateAddressId; });

                let newAddressFileKey = lodash.lastIndexOf(this.props.clientData.allAddresses[addressIndex].files);
                if(newAddressFileKey == '-1')
                {
                    newAddressFileKey = 0;
                }


                let newFileKey = lodash.lastIndexOf(this.props.fileData.files);
                if(newFileKey == '-1')
                {
                    newFileKey = 0;
                }

                this.setState({addressIndex: addressIndex, newAddressFileKey: newAddressFileKey, newFileKey: newFileKey});
            }
            let addressId = this.state.selectedAddress.value;

            if(this.props.match.params.addressId) {
                addressId = this.props.match.params.addressId;
            }

            if(this.props.match.params.fileId && prevstate.file != this.state.file) {
                addressId = this.state.file.addresses[0].value;
            }

            if(this.props.hasBeenEdited) {
                this.props.fileEdited(false);

                if(addressId) {
                    this.props.history.push('/addresses/view/' + addressId);
                }
            }

            // -- for editing purposes
            if(this.props.match.params.fileId) {

                const fileId = this.props.match.params.fileId;


                const file =  this.props.fileData.files.find(e => e.id === fileId);
                const fileIndex = lodash.findIndex(this.props.fileData.files, function(value) { return value.id === fileId; });

               
                // -- get address index to update firebase
                const addressIndex = lodash.findIndex(this.props.clientData.allAddresses, function(value) { return value.dp_address_id === file.addresses[0].value; });

                // -- find file index in address array
                const addressFileIndex = lodash.findIndex(this.props.clientData.allAddresses[addressIndex].files, function(value) { return value.id === fileId; });

                this.setState({
                    file: file,
                    attached_values: file.attached_values,
                    file_type_id: file.file_type_id,
                    product_id: file.product_id,
                    selectedAddress: {'value':file.addresses[0].value},
                    fileIndex: fileIndex,
                    addressFileIndex: addressFileIndex,
                    addressIndex: addressIndex,
                    fileEdit: true,
                    is_been_notified: file.is_been_notified

                })
            }

            if(this.props.match.params.addressId ) {
                const addressId = this.props.match.params.addressId;
                const address = this.props.clientData.allAddresses.find(e => e.dp_address_id === addressId);

                // -- get address index to update firebase
                const addressIndex = lodash.findIndex(this.props.clientData.allAddresses, function(value) { return value.dp_address_id === addressId; });

                let newAddressFileKey = lodash.lastIndexOf(this.props.clientData.allAddresses[addressIndex].files);
                if(newAddressFileKey == '-1')
                {
                    newAddressFileKey = 0;
                }


                let newFileKey = lodash.lastIndexOf(this.props.fileData.files);
                if(newFileKey == '-1')
                {
                    newFileKey = 0;
                }



                this.setState({selectedAddress: {'value':address.dp_address_id}, addressIndex: addressIndex, newAddressFileKey: newAddressFileKey, newFileKey: newFileKey, newFile: true});
            }

        }

    }

    handleSubmit(e) {
        e.preventDefault();
        let fileId = false;

        //this.props.editingInProgress(true);

        if(this.state.file) {
            fileId = this.state.file.id
        }

        this.props.uploadFile(this.props.clientPath.clientPath, this.state.files, this.state, fileId);
    }

    onDrop(files) {
        this.setState({
          files
        });
      }

    getFilePreview() {
          if(!this.state.file) {
              return <div></div>
          }
          return(
              <div>
              <div className="alert alert-danger">Let op, je bestand wordt overschreven.</div>
              <p>Je bewerkt: {this.state.file.filename} </p>
              {this.state.file.source.match(/.(jpg|jpeg|png|gif)$/i) ? <img className="img-responsive" src={this.state.file.source} /> : <a href={this.state.file.source} target="_BLANK">Bekijk bestand</a> }
              </div>
        )
    }

    getButtonMessage() {
        let buttonValue = ''

        if(this.state.file)
            buttonValue = 'Update'
        else
            buttonValue = 'Toevoegen'

        return <span><i className="fa fa-dot-circle-o"></i> {buttonValue}</span>
    }

    render() {
        let dropzoneClass = this.state.file ? 'col-md-4 hidden-col' : 'col-md-4';
        let fileMetaClass = this.state.file ? 'col-md-12' : 'col-md-8';

        return (

            <div className="animated fadeIn">
                <div className="row">
                    <div className="col-md-12">
                        <Card>
                            <CardBody>
                                <CardTitle><i className="fa fa-file"></i> Bestand {this.state.file ? 'Updaten' : 'Toevoegen'}</CardTitle>
                            <Row>

                                <div className={dropzoneClass}>
                                    <Dropzone onDrop={this.onDrop.bind(this)} multiple={false} className="dropzone" activeClassName={"active"} acceptClassName={"accept"} rejectClassName={"reject"}>
                                        <div className="dropzone-table">
                                            <div className="dropzone-table-cell">

                                                {this.state.files.length > 0 ? <h3>Toegevoegd bestand</h3> : <h3>Sleep bestanden in dit vlak of klik om te uploaden.</h3>} (maximaal 1)
                                                <ul>
                                                    {
                                                      this.state.files.map(f => <li key={f.name}>{f.name}<span className={"filesize"}>({f.size} bytes)</span></li>)
                                                    }
                                                  </ul>
                                            </div>
                                        </div>
                                    </Dropzone>
                                    <br />
                                    {this.getFilePreview()}
                                    <br />


                                </div>
                                <div className={fileMetaClass}>

                                   {this.state.file || this.state.newFile ? <FileMetaForm setIsBeenNotified={this.setIsBeenNotified} is_priority={this.state.is_priority} setMessageOption={this.setMessageOption} fileEdit={this.state.fileEdit} setTextValue={this.setTextValue} setAddress={this.setAddress} attachedValues={this.state.attached_values} setProductId={this.setProductId} setFileType={this.setFileType} setCheckedValue={this.setCheckedValue} file={this.state.file ? this.state.file : null} /> : <Loader />}
                                </div>
                            </Row>
                                <div className="card-footer">
                                <button disabled={ this.props.isUploadInProgress === true ? 'disabled' : null }  type="submit" className="btn btn-sm btn-primary" onClick={this.handleSubmit}>
                                    { this.props.isEditingInProgress === true ? <CircularProgress size={16}  /> : this.getButtonMessage() }
                                </button>&nbsp;
                            </div>
                            </CardBody>
                        </Card>
                    </div>
                </div>
            </div>
        )
    }
}


function mapStateToProps(state, ownProps) {

    return {
        clientData: state.ClientDataReducer,
        searchData: state.SearchDataReducer,
        clientPath: state.clientPathReducer,
        fileData: state.FileReducer.files,
        lastFile: state.FileReducer.lastAdded,
        hasBeenEdited: state.FileReducer.hasBeenEdited,
        isEditingInProgress: state.LoaderReducer.EditingInProgress,
        user: state.UserReducer,
        metaDataValue : state.FileMetaDataValueReducer.data,
        products: state.ProductReducer.products,
        fileTypeData: state.FileTypeDataReducer,
        metaDataValueByCategory:state.FileMetaDataValueReducer.dataWithCategory
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        uploadFile: (url, data, postData, fileId) => dispatch(uploadFile(url, data, postData, fileId)),
        removeLastFileId : () => dispatch(removeLastFileId()),
        fileEdited : (status) => dispatch(fileEdited(status)),
        editingInProgress : (status) => dispatch(editingInProgress(status)),
        getAllFiles: (url) => dispatch(getAllFiles(url)),
        getAllProducts: (url) => dispatch(getAllProducts(url)),
        fileTypeFetchData: (url) =>   dispatch(fileTypeFetchData(url + '/api/files/action/getFileTypes')),
        fileMetaDataValueWithCategoryFetchData: (url) => dispatch(fileMetaDataValueWithCategoryFetchData(url + '/api/files/action/getMetaValuesByCategory')),
        fileMetaDataValueFetchData: (url) => dispatch(fileMetaDataValueFetchData(url + '/api/files/action/getFileMetaDataValue')),
        clientFetchData: (url) => dispatch(clientFetchData(url + '/api/clients/action/getclients'))
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form))



// WEBPACK FOOTER //
// ./src/views/Files/Form/index.js